import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

import { Server, Users, Lightbulb } from 'lucide-react';

interface AdRevenueModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

const AdRevenueModal: React.FC<AdRevenueModalProps> = ({ isOpen, onOpenChange }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px] bg-card text-card-foreground border-border shadow-lg">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-primary flex items-center gap-2">
            Reklámbevételek felhasználása
          </DialogTitle>
          <DialogDescription className="text-muted-foreground mt-2">
            Az oldal fenntartása és fejlesztése folyamatos költségekkel jár. Az alábbiakban láthatod, mire fordítjuk a reklámokból befolyó összeget.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="flex items-start gap-3">
            <Server size={20} className="text-blue-400 flex-shrink-0 mt-1" />
            <div>
              <h4 className="font-semibold text-foreground">Szerver és infrastruktúra</h4>
              <p className="text-sm text-muted-foreground">Az oldal szervereinek és a domain költségeinek biztosítására.</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <Users size={20} className="text-purple-400 flex-shrink-0 mt-1" />
            <div>
              <h4 className="font-semibold text-foreground">Weboldal fejlesztések</h4>
              <p className="text-sm text-muted-foreground">Új webdesing módosításának és a fejlesztés során felmerülő esetleges költségeire.</p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <Lightbulb size={20} className="text-yellow-400 flex-shrink-0 mt-1" />
            <div>
              <h4 className="font-semibold text-foreground">Fordítók támogatása</h4>
              <p className="text-sm text-muted-foreground">A fentmaradó összeget az aktív fordítóink között osztjuk szét.</p>
            </div>
          </div>
        </div>
        <p className="text-center text-sm text-muted-foreground mt-4">
          Köszönjük, hogy támogatod a Gep.Monster közösségét!
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default AdRevenueModal;